import React, { useEffect, useState } from 'react';
interface FlywheelNode {
  id: number;
  label: string;
  angle: number;
  description: string;
}
const nodes: FlywheelNode[] = [{
  id: 1,
  label: 'More users',
  angle: -90,
  description: 'Organic growth from word of mouth'
}, {
  id: 2,
  label: 'Richer neighborhood\nunderstanding',
  angle: -30,
  description: 'Every query teaches Navi about a place'
}, {
  id: 3,
  label: 'Better recommendations',
  angle: 30,
  description: 'Precision improves with each interaction'
}, {
  id: 4,
  label: 'More engagement',
  angle: 90,
  description: 'Users come back because it works'
}, {
  id: 5,
  label: 'More behavioral signals',
  angle: 150,
  description: 'Actions > opinions. Training data'
}, {
  id: 6,
  label: 'Deeper vibe map',
  angle: 210,
  description: 'The human layer gets richer'
}];
export function FlywheelSlide() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isHovering, setIsHovering] = useState(false);
  // Auto-rotate highlight
  useEffect(() => {
    if (isHovering) return;
    const interval = setInterval(() => {
      setActiveIndex(current => (current + 1) % nodes.length);
    }, 2500);
    return () => clearInterval(interval);
  }, [isHovering]);
  return <section className="slide" style={{
    backgroundColor: '#0d1520'
  }} data-id="element-218">
      <div className="flex flex-col items-center justify-center w-full h-full min-h-0 relative overflow-hidden" data-id="element-219">
        {/* Top label */}
        <p className="italic font-semibold animate-fade-slide" style={{
        color: '#4A90D9',
        fontSize: 'var(--body-size)',
        marginBottom: 'clamp(0.5rem, 1vw, 0.75rem)',
        animationDelay: '0.1s'
      }} data-id="element-220">
          The compounding advantage.
        </p>

        {/* Heading */}
        <h1 className="font-black tracking-tight leading-[0.95] text-white text-center animate-fade-slide" style={{
        fontSize: 'var(--title-size)',
        marginBottom: 'clamp(1.5rem, 3vw, 2.5rem)',
        animationDelay: '0.15s'
      }} data-id="element-221">
          Every interaction deepens the map.
        </h1>

        {/* Interactive Flywheel */}
        <div className="relative animate-fade-slide flex items-center justify-center" style={{
        width: 'min(55vh, 90vw, 500px)',
        height: 'min(55vh, 90vw, 500px)',
        animationDelay: '0.25s'
      }} onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)} data-id="element-222">
          {/* SVG Ring Background */}
          <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet" data-id="element-223">
            {/* Base dashed ring */}
            <circle cx="50" cy="50" r="35" fill="none" stroke="rgba(74, 144, 217, 0.15)" strokeWidth="0.5" strokeDasharray="2 2" data-id="element-224" />
            {/* Animated solid ring segment — centered on active node */}
            <circle cx="50" cy="50" r="35" fill="none" stroke="#4A90D9" strokeWidth="0.8" strokeDasharray="37 183" strokeDashoffset="0" className="origin-center transition-transform duration-1000 ease-in-out" style={{
            transform: `rotate(${nodes[activeIndex].angle - 27}deg)`
          }} data-id="element-225" />
          </svg>

          {/* Center Info Card */}
          <div className="absolute z-10 flex flex-col items-start pointer-events-none rounded-xl overflow-hidden" style={{
          width: 'clamp(160px, 55%, 240px)',
          backgroundColor: 'rgba(255,255,255,0.05)',
          border: '1px solid rgba(255,255,255,0.1)',
          borderBottom: '2px solid #4A90D9',
          padding: 'clamp(0.6rem, 1.5vw, 1rem) clamp(0.75rem, 1.8vw, 1.25rem)',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)'
        }} data-id="element-226">
            {/* Step indicator + dot */}
            <div className="flex items-center" style={{
            gap: 'clamp(0.3rem, 0.6vw, 0.5rem)',
            marginBottom: 'clamp(0.25rem, 0.5vw, 0.4rem)'
          }} data-id="element-227">
              <div className="rounded-md flex-shrink-0" style={{
              width: 'clamp(14px, 1.5vw, 20px)',
              height: 'clamp(14px, 1.5vw, 20px)',
              backgroundColor: '#4A90D9',
              borderRadius: 'clamp(3px, 0.4vw, 5px)'
            }} data-id="element-228" />
              <span className="uppercase tracking-[0.15em] font-bold" style={{
              color: '#4A90D9',
              fontSize: 'clamp(0.5rem, 0.85vw, 0.7rem)'
            }} data-id="element-229">
                Step {activeIndex + 1} of {nodes.length}
              </span>
            </div>

            {/* Label */}
            <p className="font-bold text-white leading-snug" style={{
            fontSize: 'clamp(0.75rem, 1.3vw, 1.05rem)',
            marginBottom: 'clamp(0.2rem, 0.4vw, 0.35rem)'
          }} data-id="element-230">
              {nodes[activeIndex].label.replace('\n', ' ')}
            </p>

            {/* Description */}
            <p className="leading-snug" style={{
            color: 'rgba(255,255,255,0.5)',
            fontSize: 'clamp(0.55rem, 0.9vw, 0.75rem)',
            marginBottom: 'clamp(0.4rem, 0.8vw, 0.6rem)'
          }} data-id="element-231">
              {nodes[activeIndex].description}
            </p>

            {/* Progress dots */}
            <div className="flex items-center w-full" style={{
            gap: 'clamp(3px, 0.4vw, 5px)'
          }} data-id="element-232">
              {nodes.map((_, i) => <div key={i} className="transition-all duration-500" style={{
              height: 'clamp(3px, 0.4vw, 4px)',
              flex: i === activeIndex ? 2 : 1,
              borderRadius: '2px',
              backgroundColor: i === activeIndex ? '#4A90D9' : i < activeIndex ? 'rgba(74, 144, 217, 0.3)' : 'rgba(255,255,255,0.15)'
            }} data-id="element-233" />)}
            </div>
          </div>

          {/* Nodes — numbered circles only, no text labels */}
          {nodes.map((node, index) => {
          const isActive = index === activeIndex;
          // Calculate position on the circle (radius = 35% of container)
          const rad = node.angle * Math.PI / 180;
          const radius = 35; // matches SVG circle r
          const x = 50 + radius * Math.cos(rad);
          const y = 50 + radius * Math.sin(rad);
          return <div key={node.id} className="absolute flex items-center justify-center cursor-pointer transition-all duration-300" style={{
            left: `${x}%`,
            top: `${y}%`,
            transform: 'translate(-50%, -50%)',
            zIndex: isActive ? 20 : 10
          }} onClick={() => setActiveIndex(index)} data-id="element-234">
                {/* Outer pulse ring when active */}
                <div className={`absolute rounded-full transition-all duration-500 ${isActive ? 'opacity-100 scale-[1.8]' : 'opacity-0 scale-100'}`} style={{
              width: 'clamp(28px, 3.5vw, 40px)',
              height: 'clamp(28px, 3.5vw, 40px)',
              backgroundColor: 'rgba(74, 144, 217, 0.15)',
              border: '1px solid rgba(74, 144, 217, 0.4)'
            }} data-id="element-235" />
                {/* Numbered circle */}
                <div className="rounded-full flex items-center justify-center relative z-10 transition-all duration-300" style={{
              width: 'clamp(28px, 3.5vw, 40px)',
              height: 'clamp(28px, 3.5vw, 40px)',
              backgroundColor: isActive ? '#4A90D9' : 'rgba(13, 21, 32, 0.9)',
              border: `2px solid ${isActive ? '#fff' : 'rgba(74, 144, 217, 0.4)'}`,
              boxShadow: isActive ? '0 0 20px rgba(74, 144, 217, 0.5), 0 0 40px rgba(74, 144, 217, 0.2)' : 'none'
            }} data-id="element-236">
                  <span className="font-bold leading-none transition-colors duration-300" style={{
                fontSize: 'clamp(11px, 1.4vw, 16px)',
                color: isActive ? '#fff' : 'rgba(74, 144, 217, 0.6)'
              }} data-id="element-237">
                    {node.id}
                  </span>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}